import shared from "emun.salesrep/salesrep.config.es6";
import resolve from "ioc/resolve";

export default Object.assign(shared, {
	showNewCustomerVendorCountWidget: false,
	hideDashboardNotifications: true,
	showSalesBySegment: true,
	adminGoalsBy: 'Vendor'
});
